import ExtractModal from './ExtractModal';

export default ExtractModal;
